<template>  
  <div v-if="showTransDetail" class="trans-modal">
		<div class="modal-content-container">
			<div class="modal-content">
				<div class="modal-header">
					<h3>
						{{ modalTransDetail.product.toUpperCase() }}
					</h3>
					<button class="close-btn" @click="closeModal">
						<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 18L18 6m0 12L6 6"/></svg>
					</button>
				</div>
				<div class="modal-body">
          <div class="modal-grid">
            <div class="grid-row">
              <div class="grid-col">
                <h3>Wallet Details</h3>
                <div class="item-row">
                  <p>Terminal ID:</p>
                  <p>{{ modalTransDetail.terminalId }}</p>
                </div>
                <div class="item-row">
                  <p>Agent ID:</p>
                  <p>{{ modalTransDetail.agentId }}</p>
                </div>
              </div>
              <div class="grid-col">
                <h3>Service Details</h3>
                <div class="item-row">
                  <p>Channel:</p>
                  <p>{{ }}</p>
                </div>
                <div class="item-row">
                  <p>Message:</p>
                  <p>{{ }}</p>
                </div>
              </div>
            </div>
            <div class="grid-row">
              <div class="grid-col">
                <h3>Customer Details</h3>
                <div class="item-row">
                  <p>Phone number:</p>
                  <p>{{ }}</p>
                </div>
                <div class="item-row">
                  <p>Name:</p>
                  <p>{{ }}</p>
                </div>
              </div>
              <div class="grid-col">
                <h3>Transaction References</h3>
                <div class="item-row">
                  <p>Sequence:</p>
                  <p>{{ }}</p>
                </div>
                <div class="item-row">
                  <p>Ref:</p>
                  <p class="text-truncate" :title="modalTransDetail.reference" style="max-width: 150px;">
                    {{ modalTransDetail.reference }}
                  </p>
                </div>
              </div>
            </div>
            <div class="grid-row">
              <div class="grid-col">
                <h3>Transaction Details</h3>
                <div class="item-row">
                  <p>Amount:</p>
                  <p>N{{ withdrawalAmount }}</p>
                </div>
                <div class="item-row">
                  <p>Account Number:</p>
                  <p>{{  }}</p>
                </div>
              </div>
              <div class="grid-col">
                <h3></h3>
                <div class="item-row">
                  <p>Response</p>
                  <textarea name="" id="" cols="30" rows="10">{{ modalTransDetail.response }}</textarea>
                </div>
              </div>
            </div>
            <div class="grid-row">
              <div class="grid-col">
                  <p>Requery Response</p>
                  <textarea cols="30" rows="10">{{ modalTransDetail.requeryResponse }}</textarea>
              </div>
            </div>
          </div>
					
				</div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="updateModal(modalTransDetail)">
            Show receipt
					</button>
				</div>
			</div>
		</div>
    <WithdrawalReceiptModal :show-receipt="showReceipt" :receipt-detail="receiptDetail" :close-receipt="closeReceipt"/>
	</div>
</template>

<script>
import WithdrawalReceiptModal from './WithdrawalReceiptModal.vue';

export default {
  components:{
    WithdrawalReceiptModal,
  },
    props: {
      showTransDetail: {
        type: Boolean,
        required: true,
      },
      closeModal: {
        type: Function,
        required: true
      },
      modalTransDetail: {
        type: Object,
        required: true,
      },
      // showReceipt: {
      //     type: Boolean,
      //     required: true,
      // },
    },
    data(){
      return{
        //  receipt
      showReceipt: false,
      receiptDetail: {},
      };
    },
    computed: {
      withdrawalAmount(){
        return (this.modalTransDetail.amount / 100).toFixed(2);
      }
    },
    methods: {
      updateModal(tran){
        this.showReceipt = true
        this.receiptDetail = tran
      },
      closeReceipt(){
			this.showReceipt = false;
      }
  }
};
</script>

<style scoped>
.trans-modal {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.modal-content-container {
	background-color: white;
  max-width: 80%;
  width: 800px;
  border-radius: 15px;
}
.modal-content {
	padding: 20px;
	border-radius: 5px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}
.modal-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close-btn {
	background-color: transparent;
	padding: 8px 20px;
	width: 10px;
	border: none;
	border-radius: 5px;
}
.close-btn svg{
  width: 20px;
  object-fit: contain;
}

.modal-body{
  padding: 30px;
}
.grid-row{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  grid-gap: 40px;
}
.grid-col{
  flex: 1;
}
.item-row{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.item-row p{
  margin: 5px 0;
}

</style>
